import { FormattedMessage } from "react-intl";


export const StepsIndicator = ({ currentStep, totalSteps }
    : { currentStep: number, totalSteps: number }) => {

    return (
        <div className="steps-indicator">
            <div id="step-x-of-x">
                <FormattedMessage id="REGISTRATION_STEPS_INDICATOR" values={{
                    currentStep, totalSteps
                }} />
            </div>

            <div>
                <span className={currentStep === 1 ? 'step-link active' : 'step-link'}>
                    <FormattedMessage id="REGISTRATION_STEPS_INDICATOR_STEP_COMPANY" />
                </span>
                <span className={currentStep === 2 ? 'step-link active' : 'step-link'}>
                    <FormattedMessage id="REGISTRATION_STEPS_INDICATOR_STEP_ACCOUNT" />
                </span>
                <span className={currentStep === 3 ? 'step-link active' : 'step-link'}>
                    <FormattedMessage id="REGISTRATION_STEPS_INDICATOR_STEP_PAYMENT" />
                </span>
            </div>
        </div>
    )
}
